import { View } from "react-native";
import GatheringAccessEnum from "src/api/graphql/__generated__/enums/GatheringAccessEnum";
import GatheringRelationshipEnum from "src/api/graphql/__generated__/enums/GatheringRelationshipEnum";
import Menu from "src/components/Menu";
import { useClientId } from "src/helpers/globalHelpers";
import {
	UseGatheringAndUsers_Gathering,
	UseGatheringAndUsers_User,
} from "src/hooks/useGatheringAndUsers";
import IconVerticalEllipsis from "src/icons/IconVerticalEllipsis";
import useGatheringViewerOptions from "../hooks/useGatheringViewerOptions";

const GatheringViewerOptions = ({
	user,
	access,
	gatheringId,
	onAction,
}: {
	user: UseGatheringAndUsers_User;
	access: UseGatheringAndUsers_Gathering["access"];
	gatheringId: string;
	onAction: undefined | (() => void);
}) => {
	const { handleDemoteAdmin, handlePromoteAdmin, handleRemoveFromGathering } =
		useGatheringViewerOptions({
			gatheringId,
			user,
			onAction,
		});
	const clientId = useClientId();

	if (access !== GatheringAccessEnum.Admin) return null;
	const size = 22;
	if (user.userId === clientId || !user.gatheringRelationship) {
		return (
			<View
				style={{
					width: size,
					height: size,
				}}
			/>
		);
	}

	const isUserAdmin = user.gatheringRelationship === GatheringRelationshipEnum.Admin;
	return (
		<Menu.Root>
			<Menu.Trigger>
				<IconVerticalEllipsis size={size} />
			</Menu.Trigger>
			<Menu.Content>
				{isUserAdmin ? (
					<Menu.Item key="demote" onSelect={handleDemoteAdmin} destructive>
						<Menu.ItemTitle>Remove cohost</Menu.ItemTitle>
					</Menu.Item>
				) : (
					<Menu.Item key="promote" onSelect={handlePromoteAdmin}>
						<Menu.ItemTitle>Add cohost</Menu.ItemTitle>
					</Menu.Item>
				)}
				<Menu.Item
					key="removeFromGathering"
					onSelect={handleRemoveFromGathering}
					destructive
				>
					<Menu.ItemTitle>Remove</Menu.ItemTitle>
				</Menu.Item>
			</Menu.Content>
		</Menu.Root>
	);
};
export default GatheringViewerOptions;
